import Vue from "vue";
import API from "../services/apiservices";

export default {
  namespaced: true,
  namespace: "idiomasStore",

  state: {
    idiomas: {
      lang: "pt",
      data: [
      { lang: "pt", locale: "pt-BR", caption: "Português", currency: "BRL" },
      { lang: "es", locale: "es-ES", caption: "Español", currency: "ARS" },
      { lang: "en", locale: "en-US", caption: "English", currency: "USD" },
      { lang: "ch", locale: "ch-CN", caption: "中文", currency: "CNY" },
      { lang: "it", locale: "it-IT", caption: "Italiano", currency: "EUR" },
      ]
    },
     emptyidiomas: {
      lang: null,
      api: null,
      data: [],
      error: null
    },
  },

  getters: {
    gtxStore: () => ({ name: "idiomasStore", route: "Servicos/Idiomas/Get", setter: "setIdiomas" }),
    gtxIdiomas: (state) => (state.idiomas),
    gtxIdiomasData: (state) => (state.idiomas.data),
    gtxIdiomasLang: (state) => (state.idiomas.lang),
  },

  mutations: {
    setIdiomas: (state, idiomas) => {
      if (idiomas && idiomas.apiresponse && idiomas.data && idiomas.data.length > 0) {
        state.idiomas.api = idiomas.apiresponse;
        state.idiomas.lang = idiomas.lang;
        state.idiomas.data = idiomas.data;
        state.idiomas.error = null;
      } else { state.idiomas = state.emptyidiomas }
    },    
    setIdiomasdata: (state, data) => state.idiomas.data = data,
    setIdiomaslang: (state, data) => state.idiomas.lang = data
  },

  actions: {
    actIdiomasGet({ commit, getters, dispatch }) {
      
      // tem que definir um getter com os dados da store conforme o exemplo:
      // gtxStore: () => ({name: "clientesStore", route: "Servicos/clientes/Get", setter: "setClientes"}),

      // verifica a última atualização da store ...
      return new Promise((res, rej) => {
        try {
          // console.log(new Date().toTimeString().substring(0, 8), "- Carregando", getters.gtxStore.name);
          API.get("Servicos/Stores/Get", { StoreName: getters.gtxStore.name }, false).then((apidata) => {
            let storeUpdate = new Date('02/12/2022'); // para quando não houver data de atualiação da store gravada
            let localUpdate = new Date('01/12/2022');
            const data = API.prepareData(apidata.data);
            if (data.success) {
              storeUpdate = new Date(data.data[0].Updated);
            }
            API.getLocalDBDocument(getters.gtxStore.name).then((doc) => {
              if (doc) localUpdate = doc.data.updated;
              if (localUpdate > storeUpdate) {
                console.log(new Date().toTimeString().substring(0, 8), "- Buscou do IndexDB:", getters.gtxStore.name);
                commit(getters.gtxStore.setter, doc.data);
                dispatch('actClientesCodigo_ClienteGet');
                res(doc.data);
              } else {
                API.get(getters.gtxStore.route, {}, false).then((apidata) => {
                  const data = API.prepareData(apidata.data);
                  commit(getters.gtxStore.setter, data);
                  API.setLocalDBDocument({ data: data }, getters.gtxStore.name);
                  dispatch('actClientesCodigo_ClienteGet');
                  res(data);
                });
              }
            });
          });
        } catch (err) {
          rej(err);
        }
      });
    },
    actIdiomasLangSet({ commit }, lang) {
      // console.log('actIdiomasLangSet.codigo', lang);
      commit("setIdiomaslang", lang);

      API.getLocalDBDocument("globalStore").then((doc) => {
        if (doc && doc.data) {
          doc.data.lang = lang;
          API.setLocalDBDocument({ data: doc.data }, "globalStore");
        } else {
          API.setLocalDBDocument({ data: {lang: lang} }, "globalStore");
        }
      });
    }
  }
}